<template>
	<div id="page">
		<div class="page-content">
			<div class="page-title page-title-small">
				<h2><button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>مشخصات کاربر </h2>
				<button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
			</div>
			<div class="card header-card shape-rounded" data-card-height="150">
				<div class="card-overlay bg-highlight opacity-95"></div>
				<div class="card-overlay dark-mode-tint"></div>
				<div class="card-bg bg-20"></div>
			</div>
			<div class="card card-style">
				<div class="content mb-0">
					<div class="input-style input-style-2 has-icon input-required">
						<i class="input-icon fa fa-check color-magenta2-light"></i>
						<span class="color-highlight" :class="{'input-style-1-active' : userModel.title!==null}">عنوان</span>
						<input class="form-control" type="text" v-model="userModel.title" @input="v$.userModel.title.$touch()" :class="{invalid:v$.userModel.title.$error}">
						<p class="text-danger" v-if="v$.userModel.title.required.$invalid && v$.userModel.title.$dirty">لطفا عنوان را وارد کنید.</p>
					</div>

					<div class="mb-3">
						<v-select v-if="userModel.userId!=0 && OrgJobList!=[]" dir="rtl" label="title" placeholder="پست سازمانی" :filterable="OrgJobList.length>10" :searchable="OrgJobList.length>10" :options="OrgJobList" :reduce="x=>x.orgJobId" v-model="userModel.orgJobId">

						</v-select>
						<p class="text-danger" v-if="v$.userModel.orgJobId.required.$invalid && v$.userModel.orgJobId.$dirty">لطفا پست سازمانی را وارد کنید.</p>
					</div>

					<div class="col-8 py-2">
						<div class="fac fac-checkbox fac-orange">
							<span></span>
							<input id="box3-fac-checkbox" type="checkbox" v-model="userModel.accessToRelativeGroup">
							<label for="box3-fac-checkbox">دسترسی به وظایف همکاران</label>
						</div>
					</div>
					<div class="col-8 py-2">
						<div class="fac fac-checkbox fac-orange">
							<span></span>
							<input id="box1-fac-checkbox" type="checkbox" v-model="userModel.smS_Notification">
							<label for="box1-fac-checkbox">ارسال پیامک اطلاع رسانی</label>
						</div>
					</div>
					<div class="col-8 py-2">
						<div class="fac fac-checkbox fac-orange">
							<span></span>
							<input id="box4-fac-checkbox" type="checkbox" v-model="userModel.sendTaskCloseSms">
							<label for="box4-fac-checkbox">اعلان اطلاع رساتی درخواست بستن</label>
						</div>
					</div>
					<div class="col-8 py-2">
						<div class="fac fac-checkbox fac-orange">
							<span></span>
							<input id="box5-fac-checkbox" type="checkbox" v-model="userModel.sendTaskTeamUserSms">
							<label for="box5-fac-checkbox">ارسال پیامک سایر اعضاء تیم</label>
						</div>
					</div>
					<div class="col-8 py-2" v-if="!isMinVersion">
						<div class="fac fac-checkbox fac-orange">
							<span></span>
							<input id="box7-fac-checkbox" type="checkbox" v-model="userModel.sendTaskWorkSms">
							<label for="box7-fac-checkbox">ارسال پیامک ثبت پیگیری</label>
						</div>
					</div>
					<div class="col-8 py-2">
						<div class="fac fac-checkbox fac-orange">
							<span></span>
							<input id="box6-fac-checkbox" type="checkbox" v-model="userModel.workMonthAccess">
							<label for="box6-fac-checkbox">ثبت کارکرد ماهانه</label>
						</div>
					</div>
					<div class="col-8 py-2">
						<div class="fac fac-checkbox fac-orange">
							<span></span>
							<input id="box2-fac-checkbox" type="checkbox" v-model="userModel.email_Notification">
							<label for="box2-fac-checkbox">ارسال ایمیل</label>
						</div>
					</div>

					<!-- <div class="col-6">
		<div class="fac fac-checkbox fac-red">
			<span></span>
			<input id="box6-fac-checkbox" type="checkbox" v-model="userModel.disabled">
			<label for="box6-fac-checkbox">غیرفعال</label>
		</div>
	</div> -->

					<button :disabled="Loading" class="btn btn-xxs mt-4 mb-4 btn-full bg-green1-dark rounded-sm font-900 w-100" @click.prevent="CreateLocaluserList">
						<i class="fa fa-check font-10 ml-2"></i>
						ثبت
					</button>
				</div>
			</div>
		</div>
	
		<transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
			<div v-if="Loading" class="w-100 d-flex justify-content-center loadingBox">
				<div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>درحال ارسال اطلاعات ...</div>
			</div>
		</transition>
	</div>
</template>
<script>
import useVuelidate from '@vuelidate/core'
	import {
		required
	} from "@vuelidate/validators";
	import 'vue-select/dist/vue-select.css';

	export default {
setup: () => ({ v$: useVuelidate() }),
		data() {
			return {
				testData:null,
				userModel: {
					userCode: "",
					title: null,
					orgJobTitle: 0,
					orgJobId: 0,
					userId: 0,
					disabled: false,
					adminOrUser: true,
					accessToRelativeGroup: true,
					workMonthAccess: false,
                    sendTaskWorkSms: false,
                    sendTaskTeamUserSms:false,
                    sendTaskCloseSms:false,
					email_Notification: false,
                    smS_Notification:false
				},
			};
		},
		computed: {
			Loading() {
				return this.$store.getters.GetLoading;
			},
			OrgJobList() {
				return this.$store.getters.GetOrgJobList;
			},
		},
		created() {
			this.GetOrgJobList();
			this.GetLocaluserListItem();

		},
		methods: {
			GetOrgJobList() {
				this.$store.dispatch("GetOrgJobListFromServer");
			},
			GetLocaluserListItem() {
				this.$http.get("Task/GetUserItemForAdmin?id=" + this.$route.params.userId)
					.then(data => {
						this.userModel = data.data;
						this.userModel.orgJobId = data.data.orgJobId;
						this.testData = data.data;
					});
			},
			CreateLocaluserList() {
				this.v$.$touch();
				if (!this.v$.$invalid) {
					this.$store.dispatch("UpdateUser", this.userModel);
				}
			},

		},
		validations: {
			userModel: {
				title: {
					required
				},
				orgJobId: {
					required
				},

			}


		},

	};
</script>
